import { IconButton } from "@material-ui/core";
import VisibilityOutlinedIcon from "@material-ui/icons/VisibilityOutlined";
import { FC } from "react";
import { useRedirect } from "react-admin";

import TooltipPopover from "../../../components/TooltipPopover";
import { AppResource } from "../../../types/resource.types";

const ShowOrderDetailsButton: FC<any> = ({ record }) => {
  const order = record;
  const redirect = useRedirect();

  const redirectShowOrder = () => {
    redirect(`/${AppResource.orders}/${order.id}`);
  };

  return (
    <TooltipPopover message="Show order details">
      <IconButton onClick={redirectShowOrder}>
        <VisibilityOutlinedIcon color="primary" />
      </IconButton>
    </TooltipPopover>
  );
};

export default ShowOrderDetailsButton;
